import ImageCropField from './ImageCropField';

interface ImageUploadCropperProps {
  label?: string;
  currentImage?: string;
  onUpload: (file: File) => void;
  onDelete: () => void;
}

/**
 * Recortador de imagen de aspecto libre (logos).
 *
 * El usuario arrastra el cursor sobre la imagen para marcar el área a
 * conservar; también puede usar la imagen completa. La salida es PNG para
 * conservar transparencia.
 *
 * (Wrapper delgado sobre {@link ImageCropField} para no romper los consumidores.)
 */
const ImageUploadCropper: React.FC<ImageUploadCropperProps> = ({
  label = 'Imagen',
  currentImage,
  onUpload,
  onDelete,
}) => {
  return (
    <ImageCropField
      label={label}
      currentImage={currentImage}
      mimeType="image/png"
      outputName="logo.png"
      onUpload={onUpload}
      onDelete={onDelete}
    />
  );
};

export default ImageUploadCropper;
